window.CarriAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['Carri']);

    self.getCarriEmployeesList = function (brandId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/contacts", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.data.contacts) {
                    defer.resolve(res.data.data.contacts);
                } else {
                    defer.reject(res);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;

    };

    self.importEmployeesFile = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/contacts/files", "POST", params)
            .then(function (res) {
                defer.resolve(res);
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getCarriFilesUrl = function (brandId,fileName) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/contacts/files/presigned_url?filename="+fileName, "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.data.href) {
                    defer.resolve(res.data.data.href);
                } else {
                    defer.reject(res);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;

    };

    self.checkEmployeesFileStatus = function (brandId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/contacts/files?offset=0&limit=1", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.data.files) {
                    defer.resolve(res.data.data.files);
                } else {
                    defer.reject(res);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;

    };

    self.getCarriFilesList = function (brandId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/contacts/files?status=SUCCESSFUL", "GET")
            .then(function (res) {
                if (res.data && res.data.data && res.data.data.files) {
                    defer.resolve(res.data.data.files);
                } else {
                    defer.reject(res);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.startCampaign = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/campaigns", "POST", params)
            .then(function (res) {
                defer.resolve(res);
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.listCampaigns = function (brandId) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId + "/campaigns", "GET")
            .then(function(resp){
                defer.resolve(resp.data.data);
            }, function(err){
                defer.reject(err);
            });
        return defer.promise;
    };
});
